<div>
  <h3>Assign Surveys</h3>
  @if (surveys) {
    <div>
      @for (survey of surveys; track survey) {
        <div>
          {{ survey.surveyName }}
          @if (isSurveyAssignedInOtherFormula(survey)) {
            <label
              i18n="assigned in formula@@assigned_in_formula"
              >Assigned in formula:
        {{ getAssignedFormula(survey).formulaName }}</label
              >
            }
            @if (!isSurveyAssignedInOtherFormula(survey)) {
              <div>
                <button
                  mat-raised-button
                  [disabled]="isSurveyInAssignedStack(survey)"
                  (click)="assignSurvey(survey)"
                  i18n="assign@@assign"
                  >
          Assign
        </button>
                <button
                  mat-raised-button
                  [disabled]="!isSurveyInAssignedStack(survey)"
                  (click)="unassignSurvey(survey)"
                  i18n="unassign@@unassign"
                  >
          Unassign
        </button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div mat-dialog-actions>
    @if (assignedSurveys) {
      <button
        mat-button
        [disabled]="assignedSurveys.length === 0"
        [mat-dialog-close]="assignedSurveys"
        i18n="submit@@submit"
        >
    Submit
  </button>
    }
    <button mat-button color="accent" (click)="onCancel()" i18n="cancel@@cancel">Cancel</button>
  </div>
